export class CaptionToken {
    public readonly id: string;
    public readonly start: number;
    public readonly args: SpringRoll.TemplateVariables | undefined;

    constructor(pId: string, pStart: number = 0, pArgs?: any) {
        this.id = pId;
        this.start = pStart;
        this.args = pArgs;
    }
}
